import React, { useState } from 'react';
import PropTypes from 'prop-types';
import LoginComponent from './LoginComponent';
import GuestRegistrationForm from '../GuestRegistrationForm';

const LoginComponentWrapper = ({ onLogin, settings }) => {
  const { useGuestLoginLayout } = settings;
  const [guestRegisterEmail, setGuestRegisterEmail] = useState(null);

  if (guestRegisterEmail) {
    return <GuestRegistrationForm email={guestRegisterEmail} />;
  }

  return (
    <LoginComponent
      onLogin={onLogin}
      useGuestLoginLayout={useGuestLoginLayout}
      setGuestRegisterEmail={setGuestRegisterEmail}
    />
  );
};

LoginComponentWrapper.propTypes = {
  onLogin: PropTypes.func.isRequired,
  settings: PropTypes.object.isRequired
};

export default LoginComponentWrapper;
